import {
    bindListeners,
    unbindListeners,
    modalId,
    hasRemoteModalAtRoot,
} from '../util';

function cancelModal(e, vm) {
    if(vm.$options.name === 'RemoteContent') {
        e.preventDefault();
        vm.$emit('cancel');
    }
}

function openModal(e, vm, modalId) {
    if(hasRemoteModalAtRoot(vm)) {
        e.preventDefault();
        vm.$root.$emit('remote-modal::show', modalId, e.target);
    }
}

export default {
    bind(el, { arg, modifiers, value }, vnode) {
        bindListeners(['click'], el, e =>
            arg === 'cancel'
                ? cancelModal(e, vnode.context)
                : openModal(e, vnode.context, modalId({ modifiers, value }))
        );
        el.setAttribute('data-remote-modal-link', '');
    },
    inserted(el, { arg }, vnode) {
        if(arg !== 'cancel' && !hasRemoteModalAtRoot(vnode.context)) {
            console.error('Remote modal: no remote modal found, please add the <remote-modal> component in', vnode.context.$root.$el);
        }
    },
    unbind(el) {
        unbindListeners(['click'], el);
    }
}